export default "__VITE_ASSET__effe29f4__"